import { mutatorAction } from "satcheljs";
import { getStore } from "../store/store";
import { MAX_MODAL_DIALOG_SHOWN_COUNT } from "../const";

export const setIsSignInRequiredAndShowModalDialogMutator: (isSignInRequired: boolean, shouldShowModalDialog: boolean) => void = mutatorAction("setIsSignInRequiredAndShowModalDialog", (isSignInRequired: boolean, shouldShowModalDialog: boolean): void => {
    const store = getStore();
    
    // Handle showing the dialog
    if (shouldShowModalDialog && !store.shouldShowModalDialog) {
        // Only show and increment if we haven't exceeded the max count
        if (store.modalDialogShownCount < MAX_MODAL_DIALOG_SHOWN_COUNT) {
            store.shouldShowModalDialog = true;
            store.modalDialogShownCount++;
        }
    }
    // Handle hiding the dialog if requested
    else if (!shouldShowModalDialog && store.shouldShowModalDialog) {
        store.shouldShowModalDialog = false;
    }
    
    // Update isSignInRequired only if the value is changing.
    if (store.isSignInRequired !== isSignInRequired) {
        store.isSignInRequired = isSignInRequired;
    }
});
